<template>
  <v-flex class="agent-password">
    <v-card-title class="card-title">
      Password
      <span @click="showModal = true">CHANGE PASSWORD</span>
    </v-card-title>
    <v-card-text class="password-info">
      <input v-model="password" type="password" disabled>
    </v-card-text>
    <default-modal
      :show-modal="showModal"
      :max-width="'504px'"
      :modal-title="'Change Password'"
      :width="'100%'"
      @close-modal="showModal = false"
    >
      <v-flex class="agent-data-container">
        <span>CURRENT PASSWORD</span>
        <input
          v-model="profileForm.currentPassword"
          type="password"
          :placeholder="profileForm.currentPassword"
          @input="errorText = ''"
        >
        <span>NEW PASSWORD</span>
        <input
          v-model="profileForm.newPassword"
          type="password"
          :placeholder="profileForm.newPassword"
          @input="errorText = ''"
        >
        <span>CONFIRM NEW PASSWORD</span>
        <input
          v-model="profileForm.confirmPassword"
          type="password"
          placeholder="Confirm New Password"
          @input="errorText = ''"
        >
      </v-flex>
      <v-flex v-if="errorText" class="error-container">
        {{ errorText }}
      </v-flex>
      <v-flex class="logout-container">
        <input v-model="profileForm.phone" type="checkbox">
        <span> Log me out of the other computers</span>
      </v-flex>
      <v-btn
        :color="colors.hwayzBrandBlue"
        class="save-changes-button"
        @click="updateInfo"
      >
        Save Changes
      </v-btn>
      <v-btn :color="colors.hwayzWhite" class="cancel-button" @click="showModal = false">
        Cancel
      </v-btn>
    </default-modal>
  </v-flex>
</template>
<script>
import DefaultModal from '../../components/modals/DefaultModal'
import colors from '../../scss/_colors.scss'
import { updatePasswordRequest } from '../../services/commonService'

export default {
  components: {
    DefaultModal
  },

  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      password: 11111111111,
      profileForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      showModal: false,
      colors,
      errorText: ''
    }
  },
  created() {
    this.mapData()
  },

  beforeDestroy() {
    this.errorText = ''
  },

  methods: {
    async updateInfo() {
      if (
        !this.profileForm.currentPassword ||
        !this.profileForm.newPassword ||
        !this.profileForm.confirmPassword
      ) {
        this.errorText = 'Please enter all input fields'
        return
      }

      if (this.profileForm.newPassword === this.profileForm.confirmPassword) {
        this.errorText = ''
        const password = {
          oldpassword: this.profileForm.currentPassword,
          newpassword: this.profileForm.newPassword
        }
        const response = await updatePasswordRequest(password)
        if (response.status === 200) {
          // Show success alert here
          this.showModal = false
        } else {
          this.errorText = 'You have entered incorrect current password'
        }
      } else {
        this.errorText = 'New Password and confirm password should be same'
      }
    },
    mapData() {
      for (let key in this.profileForm) {
        if (this.profile && this.profile[key]) {
          this.profileForm[key] = this.profile[key]
        }
      }
    }
  }
}
</script>
<style lang="sass">
.agent-data-container
  input[type=password]
      border: 1px solid $color-grey
      height: 40px
      width:  100%
      margin: 1rem 0 2rem
      padding-left: 15px

.error-container
  text-align: left
  margin-bottom: 2rem
  font-size: 1.2rem
  color: $hwayzRed

.logout-container
  display: flex
  justify-content: flex-start
  align-items: center
  margin-bottom: 1rem
  span
    display: block
  input
    margin-right: 15px
    width: 15px
    height: 15px
.password-info
  padding: 0 16px 16px !important
  display: flex
  justify-content: flex-start
.password-info input[type=password]
  border: none
  height: 10px
</style>
